<script lang="ts">
import type { Notification, Nullable } from '@/types'
import { defineComponent } from 'vue'

/**
 * AppNotification
 */
export default defineComponent({
  computed: {
    notification(): Nullable<Notification> {
      return this.$notificationStore.nextNotification
    },
  },
})
</script>

<template>
  <AppModal
    v-if="notification"
    id="notification-modal"
    class="max-sm:w-[375px] md:max-w-screen-sm"
    :allow-dismissal="false"
    :open="$notificationStore.show"
  >
    <template #default>
      <component
        :is="$notificationStore.getNotificationComponent(notification)"
        :notification="notification"
        @close-notification="$notificationStore.hideNotification"
      />
    </template>
  </AppModal>
</template>
